<!-- 说明 -->
<template>
  <div
    class='exp_wrap'
    :style="{marginBottom:`${formSty.el_margin + 60 - formSty.padding / 2 }px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
  >
    <!--  -->
    <div class="exp_item exp_title">说明：</div>
    <div class="exp_item">1. 注册成功后，您将收到确认邮件和短信（非大陆地区参会者仅收到确认邮件），如果您在1个自然日内未能收到确认邮件或短信（非大陆地区参会者未收到确认邮件），请与我们联系：csrswtc2021@ee.cityu.edu.hk；</div>
    <div class="exp_item">2. 学生只能注册一篇论文，普通参会人员最多可注册四篇论文；</div>
    <div class="exp_item">3. 仅支持海外作者线上参会，中国大陆参会者必须现场参会；</div>
    <div class="exp_item">4. 注册时选择为线上参会，但实际到场参会的人员需要在现场补交注册费差额；</div>
    <div class="exp_item">5. 注册费一经支付，恕不受理退款；</div>
    <div class="exp_item">6. 港澳台及其他国家无法开具普票，仅提供收据；</div>
    <div class="exp_item">7. 发票将在7月7日注册签到时现场发放；收据将在7月7日通过邮件发送到参会者邮箱;</div>
    <div class="exp_item color_sty">8. 请您在转账后48小时内将付款截图发送到邮箱（bestmeeting02@163.com），工作人员将为您确认账单并给您发送会议确认短信/邮件。</div>
    <div class="final_exp">感谢大家的支持，希望我们10月在深圳相见！</div>
  </div>
</template>

<script>
export default {
  name: 'Explain',
  props: {
    formSty: {
      type: Object,
      default: () => ({
        layout: 'vertical',
        el_radius: 0,
        el_margin: 10,
        button: {
          redius: 10,
          text: '确认提交',
          bg_color: '#06f',
          color: '#fff'
        },
      })
    },
  },
  data() {
    return {

    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.exp_wrap {
  background: #fff;
  padding: 10px 15px;
  font-size: 14px;
  line-height: 18px;
  .exp_title {
    font-weight: 700;
    font-size: 16px;
  }
  .exp_item {
    margin-bottom: 5px;
    text-align: justify;
    letter-spacing: 0.5px;
  }
  .color_sty {
    color: red;
  }
  .final_exp {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #000;
    margin: 10px 0;
  }
}
</style>